import { css } from '@emotion/react';

import COLORS from 'shared/styles/colors';
import theme from 'shared/styles/themes';

export default css({
  '&.creator-profile-information': {
    backgroundColor: COLORS.NEUTRAL50,
    borderRadius: '10px',
    padding: `${theme.space[4]} ${theme.space[3]} ${theme.space[4]} ${theme.space[3]}`,
    width: '336px',
    maxHeight: '724px',
    gap: '20px',
  },
  '.creator-profile-information': {
    '&__active-brief-count': {
      width: '320px',
      gap: theme.space[1],
      justifyContent: 'space-between',
    },
  },
});
